import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnigmaDto, CreateEnigma, UpdateEnigma } from './enigmi-dto';


@Injectable({
  providedIn: 'root'
})
export class GestioneEnigmiService {

  private url = `${environment.apiUrl}/enigmas`;

  constructor(private http: HttpClient) { }



  getAllByMission(missionId: string): Observable<EnigmaDto[]> {
    return this.http.get<EnigmaDto[]>(`${this.url}/mission/${missionId}`);
  }

  getAllByStep(stepId: string): Observable<EnigmaDto[]> {
    return this.http.get<EnigmaDto[]>(`${this.url}/step/${stepId}`);
  }

  create(data: CreateEnigma): Observable<EnigmaDto> {
    return this.http.post<EnigmaDto>(`${this.url}`, data);
  }

  read(id: string): Observable<EnigmaDto> {
    return this.http.get<EnigmaDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdateEnigma): Observable<EnigmaDto> {
    return this.http.put<EnigmaDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

}
